const axios = require('axios')

const methodIdCache = new Map()

const getMethodId = async hexString => {
    if (methodIdCache.has(hexString)) {
        return methodIdCache.get(hexString)
    }

    try {
        const response = await axios.get(`https://www.4byte.directory/api/v1/signatures/?hex_signature=${hexString}`)
        const functionName = response.data.results[0]?.text_signature || hexString

        methodIdCache.set(hexString, functionName)

        return functionName
    } catch (error) {
        console.error('Error fetching method ID:', error)
        methodIdCache.set(hexString, hexString)
        return hexString
    }
}

module.exports = { getMethodId }
